// extracted by mini-css-extract-plugin
export default {"myWallet":"MyWallet__myWallet__NM5vZ","title":"MyWallet__title__JknuN","balanceNumber":"MyWallet__balanceNumber__U4oUz"};